import script from "./IFAList.vue?vue&type=script&setup=true&lang=ts"
export * from "./IFAList.vue?vue&type=script&setup=true&lang=ts"

import "./IFAList.vue?vue&type=style&index=0&id=1a570d6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a570d6a"]])

export default __exports__